import { render, staticRenderFns } from "./FdmPerformance.vue?vue&type=template&id=6e46f1e2"
import script from "./FdmPerformance.vue?vue&type=script&lang=js"
export * from "./FdmPerformance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports